export default __webpack_public_path__ + "static/media/dragon.de9857c1.png";